import { Button, Flow, Tooltip } from 'bold-ui'
import { useSession } from 'components/auth/useSession'
import { Box } from 'components/Box'
import { useState } from 'react'
import Permissions from 'types/Permissions.generated'
import { MSG_SEM_PERMISSAO_GERENCIAR_DOCUMENTOS } from 'view/cidadao/constants-cidadao'

import { useDocumentosGerenciaveis } from '../hooks/useDocumentosGerenciaveis'
import { DocumentoAssociadoFormModel, DocumentoGerenciavelFormModel } from '../types/model-cidadao'
import { CidadaoDocumentosAssociados } from './CidadaoDocumentosAssociados'
import { ModalGerenciamentoDocumentos } from './ModalGerenciamentoDocumentos'

interface GerenciamentoDocumentosBoxProps {
  documentosAssociados: DocumentoAssociadoFormModel[]
}

export const GerenciamentoDocumentosBox = ({ documentosAssociados }: GerenciamentoDocumentosBoxProps) => {
  const { hasAuthorization } = useSession()
  const podeGerenciarDocumentos = hasAuthorization(
    Permissions.gestaoDeCadastros.visualizarCadastroIndividual.cadastrarEEditar.gerenciarDocumentos
  )

  const { documentosGerenciaveis, aplicarDocumentosGerenciados } = useDocumentosGerenciaveis(documentosAssociados)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const handleOpen = () => setIsModalOpen(true)
  const handleClose = () => setIsModalOpen(false)

  const handleConfirm = (documentosGerenciados: DocumentoGerenciavelFormModel[]) => {
    aplicarDocumentosGerenciados(documentosGerenciados)
    handleClose()
  }

  const tooltipGerenciarDocumentos = podeGerenciarDocumentos ? undefined : MSG_SEM_PERMISSAO_GERENCIAR_DOCUMENTOS

  const outrosDocumentos = documentosGerenciaveis.filter((doc) => !doc.stPrincipal)
  if (outrosDocumentos.isEmpty()) return null

  return (
    <Box>
      <Flow direction='horizontal' alignItems='center' justifyContent='space-between'>
        <CidadaoDocumentosAssociados documentosAssociados={outrosDocumentos} />
        <Tooltip text={tooltipGerenciarDocumentos}>
          <Button type='button' size='small' disabled={!podeGerenciarDocumentos} onClick={handleOpen}>
            Gerenciar documentos
          </Button>
        </Tooltip>
      </Flow>
      <ModalGerenciamentoDocumentos
        isModalOpen={isModalOpen}
        documentosAssociados={documentosGerenciaveis}
        onConfirm={handleConfirm}
        onClose={handleClose}
      />
    </Box>
  )
}
